export * from './detail-section';
